<div class="flex items-center justify-between" style="position: relative; padding-right: 48px;">
  @if(actionTittles.hasOwnProperty(data.action)){
  <h2 mat-dialog-title style="margin: 0; font-size: 1.1rem;">{{data.tittle}}</h2>
  }
  @if(!data.showActionButtons){
    <button mat-icon-button mat-dialog-close aria-label="Cerrar"
      style="position: absolute; top: 16px; right: 16px; width: 35px; height: 35px; padding: 0; box-shadow: none !important; outline: none !important; border: none; display: flex; align-items: center; justify-content: center; z-index: 10;"
      tabIndex="-1"
      >
      <span style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px;">
        <mat-icon style="font-size: 22px;">close</mat-icon>
      </span>
    </button>
  }
</div>
<mat-dialog-content class="mat-typography">
  @switch (data.action) {
    @case('edit'){
      <app-crud-edit [id]="data.id"></app-crud-edit>
    }
    @case('create'){
      <app-crud-create [fields]="fields"></app-crud-create>
    }
    @case('view'){
      <app-crud-view [id]="data.id"></app-crud-view>
    }
    @case('delete'){
      Esta seguro que desea dar de baja?
      <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em;">
        <mat-label>Motivo</mat-label>
        <mat-select [(ngModel)]="data.motivo">
          <mat-option *ngFor="let option of motivosBaja; trackBy: trackByMotivo" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em;">
        <mat-label>Comentario (opcional)</mat-label>
        <textarea matInput [(ngModel)]="data.comment" rows="3" placeholder="Ingrese un comentario"></textarea>
      </mat-form-field>
    }
    @case('restore'){
      Esta seguro que desea restaurar?
      <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em;">
        <mat-label>Comentario (opcional)</mat-label>
        <textarea matInput [(ngModel)]="data.comment" rows="3" placeholder="Ingrese un comentario"></textarea>
      </mat-form-field>
    }
    @case('alert'){
     <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="done"></mat-icon>
    }
    @default{
      <div class="view-in-modal-content">
        <ng-container *ngTemplateOutlet="data.templateRefContent"></ng-container>
      </div>
    }
    <!-- @case('viewInModal'){
      <div class="view-in-modal-content">
        <ng-container *ngTemplateOutlet="data.templateRefContent"></ng-container>
      </div>
    } -->
  }


</mat-dialog-content>
@if(data.showActionButtons){
  <mat-dialog-actions align="start">
    <button matButton (click)="submit()">Guardar</button>
    <button matButton mat-dialog-close>Cancelar</button>
  </mat-dialog-actions>
}
